import {
  Avatar,
  DataTableColumn,
  Tag,
  Timestamp,
} from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';

import { BanOnUser } from 'apis/bans';
import { usersApi } from 'apis/users';
import { AppLink } from 'components/appLink';
import { channelAttributes } from 'utils/channels';

import styles from './styles.module.scss';

const AgentCell = ({ id }: { id: string }): JSX.Element => {
  const { data } = usersApi.useReadUserQuery({ id });
  const agent = data?.data;
  if (!agent) {
    return <div className={styles.userName}>—</div>;
  }
  return (
    <div className={styles.user}>
      <Avatar user={agent} />
      <div className={styles.userName}>{agent.name}</div>
    </div>
  );
};

export const banHistoryColumns: DataTableColumn<BanOnUser>[] = [
  {
    label: '#',
    selector: function renderCsid({ csid }: BanOnUser): JSX.Element {
      return (
        <AppLink
          path="/conversation/:csid"
          params={{ path: { csid: `${csid}` } }}
        >
          #{csid}
        </AppLink>
      );
    },
  },
  {
    label: 'Banned by',
    selector: function renderBannedBy({
      banning_agent_id,
    }: BanOnUser): JSX.Element {
      return <AgentCell id={banning_agent_id} />;
    },
  },
  {
    label: 'Channel',
    selector: function renderChannel({
      channel,
    }: BanOnUser): string | undefined {
      return (channel && channelAttributes[channel]?.name) || 'Unknown';
    },
  },
  {
    label: 'Status',
    selector: function renderStatus({ unbanned_at }: BanOnUser): JSX.Element {
      return (
        <Tag color={unbanned_at ? colors.neutral['500'] : colors.green['500']}>
          {unbanned_at ? 'Inactive' : 'Active'}
        </Tag>
      );
    },
  },
  {
    label: 'Banned on',
    selector: function renderBannedAt({ banned_at }: BanOnUser): JSX.Element {
      return <Timestamp relative time={banned_at} />;
    },
  },
];

export const banHistorySubColumns: DataTableColumn<BanOnUser>[] = [
  {
    label: 'Unbanned by',
    selector: function renderUnbannedBy({
      unbanning_agent_id,
    }: BanOnUser): JSX.Element | null {
      if (!unbanning_agent_id) return null;
      return <AgentCell id={unbanning_agent_id} />;
    },
  },
  {
    label: 'Unbanned on',
    selector: function renderUnbannedOn({
      unbanned_at,
    }: BanOnUser): JSX.Element | null {
      if (unbanned_at) {
        return <Timestamp relative time={unbanned_at} />;
      }
      return null;
    },
  },
];
